import useSWR from 'swr';
import type {
  NetworkType,
  PolicyWithRateLimitInfo,
} from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';

const fetcher = (url: string): Promise<PolicyWithRateLimitInfo[]> =>
  denApi.get<PolicyWithRateLimitInfo[]>(url);

export function useTransactionBuilderPolicies({
  accountId,
  networkId,
}: {
  accountId: string;
  networkId: NetworkType;
}) {
  const params = new URLSearchParams({
    accountId,
    networkId: String(networkId),
  });
  const url = `transaction-builder/policies?${params.toString()}`;

  const { data, error, isLoading, mutate } = useSWR<PolicyWithRateLimitInfo[]>(
    url,
    fetcher
  );

  return {
    policies: data,
    isLoading,
    error,
    mutate,
    loadPolicies: mutate,
  };
}
